import React, { useState } from 'react';
import { Lock } from 'lucide-react';
import { useSpeech, MicButton, Listening, parseVoiceAnswers } from './voice';

// Hands-free answers: one listen fills the form from spoken keywords (deterministic mapping).
export function VoiceAnswers({ onAnswers, parse = parseVoiceAnswers, example = '“Yes. About as expected. A little help. Confidence four.”', testId = 'fl-v-voice' }) {
  const [heard, setHeard] = useState('');
  const sp = useSpeech((text) => { setHeard(text); onAnswers(parse(text)); }, { continuous: true });
  if (!sp.supported) return null;
  return (
    <div className="fl-note" data-testid={testId}>
      <div className="fl-note-row" style={{ alignItems: 'center' }}>
        <MicButton listening={sp.listening} onClick={sp.toggle} label="Answer by voice" testId={`${testId}-mic`} />
        <div>
          <p className="fl-strong" style={{ margin: 0 }}>Answer by voice</p>
          <p className="fl-small" style={{ margin: 0 }}>Say it in one go — e.g. {example} Tap any answer to correct it.</p>
        </div>
      </div>
      {sp.listening && <Listening testId={`${testId}-listening`} />}
      {heard && <p className="fl-small" style={{ margin: 0 }} data-testid={`${testId}-heard`}>Heard: “{heard}”</p>}
      {sp.error && <span className="fl-small fl-cam-msg" style={{ margin: 0 }} data-testid={`${testId}-error`}>{sp.error}</span>}
    </div>
  );
}

// Private reflection: typed or spoken. Stays on the worker's side only.
export function Reflection({ value, onChange }) {
  const [base, setBase] = useState('');
  const sp = useSpeech((heard) => onChange(`${base}${heard}`));
  const toggleMic = () => { if (!sp.listening) setBase(value ? `${value.trim()} ` : ''); sp.toggle(); };
  return (
    <>
      <label className="fl-label" htmlFor="fl-reflection">Optional private reflection — what felt different?</label>
      <div className="fl-note-row">
        <textarea id="fl-reflection" className="fl-textarea" style={{ margin: 0 }} value={value} placeholder={sp.listening ? 'Listening…' : ''} onChange={(e) => onChange(e.target.value)} data-testid="fl-v-reflection" />
        {sp.supported && <MicButton listening={sp.listening} onClick={toggleMic} label="Speak your reflection" testId="fl-v-reflection-mic" />}
      </div>
      <p className="fl-small fl-private"><Lock size={12} /> Your reflection stays private{sp.supported ? ' — spoken words only fill this box' : ''}. Maya sees the support request and work evidence, not your private reflection.{sp.listening && <> <Listening testId="fl-v-reflection-listening" /></>}</p>
      {sp.error && <span className="fl-small fl-cam-msg" data-testid="fl-v-reflection-error">{sp.error}</span>}
    </>
  );
}
